import Component from '../core/Component'
import support from '../utils/BrowserSupport'


export default class Loader extends Component {

    static ACTIVE = 'is-active';
    static VISIBLE = 'is-visible';

    constructor(element) {
        super(element)

        this.ref = {
            message: null
        }
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(Loader.ACTIVE)) {
                this.element.classList.remove(Loader.VISIBLE)
            }
        })
    }

    show() {
        this.element.classList.add(Loader.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(Loader.ACTIVE)
    }

    hide() {
        this.element.classList.remove(Loader.ACTIVE)
    }

    setMessage(message) {
        this.ref.message.innerText = message
    }

}